'use strict'

const KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=N4nDkF'

function setStatus(status, state, message) {
  status.hidden = false
  status.dataset.state = state
  status.textContent = message
}

async function subscribe(wrapper, form) {
  const email = form.querySelector('input[type="email"]')
  const submit = form.querySelector('[type="submit"]')
  const status = wrapper.querySelector('[data-klaviyo-signup-status]')

  if (!email.value.trim() || !email.checkValidity()) {
    email.reportValidity()
    return
  }

  submit.disabled = true
  email.removeAttribute('aria-invalid')

  try {
    const response = await fetch(KLAVIYO_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2026-07-15',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: wrapper.dataset.source || 'Footer',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email.value.trim(),
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                },
              },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: wrapper.dataset.listId } },
          },
        },
      }),
    })

    if (!response.ok) {
      const result = await response.json().catch(() => null)
      throw new Error(result?.errors?.[0]?.detail || 'Something went wrong. Please try again.')
    }

    form.reset()
    setStatus(status, 'success', wrapper.dataset.successMessage)
  } catch (error) {
    email.setAttribute('aria-invalid', 'true')
    setStatus(status, 'error', error.message || 'Something went wrong. Please try again.')
  } finally {
    submit.disabled = false
  }
}

// Capture on window and stop propagation so Shopify's bot protection never sees the submit;
// it would otherwise resubmit the customer form natively via form.submit().
window.addEventListener(
  'submit',
  (event) => {
    const wrapper = event.target.closest('[data-klaviyo-signup]')
    if (!wrapper?.dataset.listId) return

    event.preventDefault()
    event.stopImmediatePropagation()
    subscribe(wrapper, event.target)
  },
  true
)
